const MoengageAtrributes = {
  ProductId: "ProductId",
  ProductName: "ProductName",
  BackPressed: "BackPressed",
  QuantityChanged: "QuantityChanged",
  EnterCode: "EnterCode",
  CodeEntered: "CodeEntered",
  CodeApplied: "CodeApplied",
  PayNow: "PayNow",
  BrandName: "BrandName",
  ApiStatus: "ApiStatus",
  BrandId: "BrandId",
  Source: "Source",
  IsUserGenerated:"IsUserGenerated",
  Origin:"Origin",
  EntitiesLoaded:"EntitiesLoaded",
  Device:"Device",
  Platform:"Platform",
  NextActivity:"NextActivity",
  Action:"Action",
  LinkClicked:"LinkClicked",
  ButtonClicked:"ButtonClicked",
  timeSpent:"timeSpent",
  SectionsShown:"SectionsShown",
  LoginMode:"LoginMode",
  LoginResult:"LoginResult",
  TabName:"TabName",
  FieldEntered:"FieldEntered",
  SignupResult:"SignupResult",
  contentType:"contentType",
  TimeofContentCreation:"TimeofContentCreation",
  DateofContentCreation:"DateofContentCreation"

  //{BackPressed, QuantityChanged, EnterCode, CodeEntered, CodeApplied, PayNow}
};

export default MoengageAtrributes;
